module.exports = __webpack_public_path__ + "static/media/IMG_9522.f0cb86ac.JPG";